import { config } from '@abyss/ui/tools/config';
import { formatter } from '../../tools/formatter';
import { useQuery } from '../../tools/useQuery';

const parseResult = result => {
  const initialState = [];

  if (result && result.providerList) {
    return (result.providerList || []).map(provider => {
      const providerName = formatter('capitalCase', provider.name);

      return {
        ...provider,
        name: providerName,
        label: `${providerName} (${provider.mpin})`,
      };
    });
  }

  if (result && result.provider) {
    let providerData = result.provider;
    providerData = providerData.filter(item => item.firstName || item.lastName);

    return providerData.map(provider => {
      const firstName = formatter('capitalCase', provider.firstName);
      const lastName = formatter('capitalCase', provider.lastName);
      let providerName = lastName;
      if (firstName) {
        providerName = `${lastName}, ${firstName}`;
      }

      return {
        ...provider,
        mpin: provider.providerMpin,
        name: providerName,
        label: `${providerName} (${provider.providerMpin})`,
      };
    });
  }

  return initialState;
};

export const useProvidersSearch = options => {
  const queryOptions = options;
  let url = `${config('DS_STARGATE_API_URL')}/provider/v1.0`;
  if (options.role === 'intake-user') {
    url = `${config('PROVIDER_API_URL_PROXY')}/provider/v2.0`;
    queryOptions.isStringify = true;
  }
  const [queryResult, queryAction] = useQuery(url, {
    ...options,
    onCompleted: result => {
      const data = result.body.data ? result.body.data : result.body;
      options.onCompleted(parseResult(data));
    },
  });

  const parsedResult = {
    ...queryResult,
    data: parseResult(queryResult.data),
  };

  return [parsedResult, queryAction];
};
